export default "__VITE_ASSET__Dv_hxEPY__"